import {
    cleanCommonParams,
    mapContentParams,
    mapImageParams,
    mapProductsParams,
    mapSalesChannelsParams,
} from './common';

const mapSocialSharingParam = (
    isCreate,
    {
        categories,
        content,
        holidayAndSeasonalCategories,
        image,
        safetyTipsCategories,
        socialSharingsCategories,
        products,
        // eslint-disable-next-line camelcase
        sales_channels,
        ...params
    },
) => {
    return new Promise((resolve) => {
        const categoryIds = [].concat(
            holidayAndSeasonalCategories,
            safetyTipsCategories,
            socialSharingsCategories,
        );

        resolve({
            social_sharing: {
                ...cleanCommonParams(params),
                ...mapContentParams(isCreate, content),
                ...mapImageParams(isCreate, image),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                // eslint-disable-next-line camelcase
                category_ids: categoryIds,
            },
        });
    });
};

export { mapSocialSharingParam };
